import {useMatchesMedia} from '../../../utils'

export function useNavbarHeight(): number {
  const isMobile = useMatchesMedia(1)

  return isMobile ? 54 : 50
}
